import React from 'react';
import cookie from 'react-cookie';
import { Button } from 'react-bootstrap';
import { MessageSquare, Search, Send } from 'lucide-react';
import styles from './BriefDetailsHowItWorks.module.scss';

const STEPS = [
  {
    title: 'Search with Ari',
    body: 'Ari, Twine’s job assistant, finds jobs that match your work.',
    Icon: Search,
  },
  {
    title: 'Send your application',
    body: 'Apply on Twine in a couple of minutes. No extra forms.',
    Icon: Send,
  },
  {
    title: 'Message the client',
    body: 'If they want to work with you, you talk it through on Twine.',
    Icon: MessageSquare,
  },
];

const saveBriefLink = () => {
  const expires = new Date();
  expires.setTime(expires.getTime() + 5 * 60 * 1000);
  cookie.save('brief-link', window.location.pathname, {
    path: '/',
    expires,
  });
};

export default function BriefDetailsHowItWorks() {
  return (
    <div className={styles.card}>
      <h2 className={styles.heading}>How it works</h2>
      <ol className={styles.steps}>
        {STEPS.map(({ title, body, Icon }) => (
          <li key={title} className={styles.step}>
            <span className={styles.tile} aria-hidden="true">
              <Icon size={18} />
            </span>
            <div>
              <p className={styles.stepTitle}>{title}</p>
              <p className={styles.stepBody}>{body}</p>
            </div>
          </li>
        ))}
      </ol>
      <div className={styles.actions}>
        <Button
          bsStyle="primary"
          href="/signup?type=seller"
          className={styles.signUpButton}
          onClick={saveBriefLink}
        >
          Sign up for free
        </Button>
        <a href="/freelancers" className={styles.learnMore}>
          Learn more
        </a>
      </div>
    </div>
  );
}
